import { render } from "./ProductMediaInfo.vue?vue&type=template&id=2cccb00c&scoped=true"
import script from "./ProductMediaInfo.vue?vue&type=script&lang=js"
export * from "./ProductMediaInfo.vue?vue&type=script&lang=js"

import "./ProductMediaInfo.vue?vue&type=style&index=0&id=2cccb00c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cccb00c"]])

export default __exports__